import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  padding-top: 8px;
`;

const Text = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.5;
`;

export default function WorksModule() {
  return (
    <Container>
      <Text>Works overview</Text>
    </Container>
  );
}


